export default __webpack_public_path__ + "static/media/accidentalInsurance.10013a6b.svg";